import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [

  {
    path: '',
    loadChildren: () =>
      import('./pages/tabs/tabs.module').then(m => m.TabsPageModule)
  },

  {
    path: 'login-signup',
    loadChildren: () =>
      import('./pages/login-signup/login-signup.module').then(m => m.LoginSignupPageModule)
  },

  {
    path: 'signup',
    loadChildren: () =>
      import('./pages/signup/signup.module').then(m => m.SignupPageModule)
  },

  {
    path: 'forgot',
    loadChildren: () =>
      import('./pages/forgot/forgot.module').then(m => m.ForgotPageModule)
  },

  {
    path: 'verify',
    loadChildren: () =>
      import('./pages/verify/verify.module').then(m => m.VerifyPageModule)
  },

  {
    path: 'verify-email',
    loadChildren: () =>
      import('./pages/verify-email/verify-email.module').then(m => m.VerifyEmailPageModule)
  },

  {
    path: 'searchresult',
    loadChildren: () =>
      import('./pages/searchresult/searchresult.module').then(m => m.SearchresultPageModule)
  },

  {
    path: 'confirmlocation',
    loadChildren: () =>
      import('./pages/confirmlocation/confirmlocation.module').then(m => m.ConfirmlocationPageModule)
  },

  {
    path: 'location-settings',
    loadChildren: () =>
      import('./pages/location-settings/location-settings.module').then(m => m.LocationSettingsPageModule)
  }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }